import { registerPlugin } from 'components/plugins-entrypoint';
import { builder } from './deduplication-plugin';

registerPlugin(builder);

